import store from "@/store/index";

let validatedToken = "";
let pendingToken = "";
let pendingValidation = null;

const clearValidationCache = () => {
  validatedToken = "";
};

store.subscribe((mutation) => {
  if (mutation.type === "auth/logout" || mutation.type === "auth/auth_token") {
    clearValidationCache();
  }
});

const loginLocation = (to) => ({
  name: "Login",
  query:
    to && to.fullPath && to.fullPath !== "/login"
      ? { redirect: to.fullPath }
      : undefined,
});

const isInvalidSessionError = (error) => {
  const status = error && error.response && error.response.status;
  return status === 401 || status === 403;
};

export default () => {
  const authenticateUser = async (to, from, next) => {
    const requiresAuthentication = (to.matched || []).some(
      (record) => record.meta && record.meta.user
    );

    if (!requiresAuthentication) return next();

    const token = store.getters["auth/_userAuthToken"];
    if (!token) {
      validatedToken = "";
      return next(loginLocation(to));
    }

    if (validatedToken === token) return next();

    try {
      let validation;
      if (pendingValidation && pendingToken === token) {
        validation = await pendingValidation;
      } else {
        pendingToken = token;
        pendingValidation = store.dispatch("auth/ValidateToken", token);
        try {
          validation = await pendingValidation;
        } finally {
          if (pendingToken === token) {
            pendingToken = "";
            pendingValidation = null;
          }
        }
      }

      if (store.getters["auth/_userAuthToken"] !== token) {
        return next(loginLocation(to));
      }

      if (validation && validation.responseCode === "00") {
        validatedToken = token;
        return next();
      }

      validatedToken = "";
      await store.dispatch("auth/Logout");
      return next(loginLocation(to));
    } catch (error) {
      if (isInvalidSessionError(error)) {
        validatedToken = "";
        await store.dispatch("auth/Logout");
        return next(loginLocation(to));
      }

      // Preserve the token when validation is unavailable, but keep protected
      // content hidden and let the user retry from the login screen.
      return next({
        name: "Login",
        query: {
          redirect: to.fullPath,
          authCheck: "unavailable",
        },
      });
    }
  };

  return { authenticateUser };
};
